// Mirrors the backend hard restriction in
// analytical_variable_service.py's `_normalize_display_name` (OR-6090): a
// free-text display label, not a SQL identifier — SQL injection is already
// closed off by the repository's bound `:data_element` parameter, so this
// only rejects characters that would render unsafely as HTML/log content:
// ASCII control characters and `<`/`>`. Everything else (quotes,
// ampersands, unicode, emoji) is legal, and there is no length cap.
// eslint-disable-next-line no-control-regex -- control-character range is the point of this check
const DISALLOWED_DISPLAY_NAME_CHARS = /[\x00-\x1f\x7f<>]/;

export const hasInvalidDisplayNameCharacters = (value: string): boolean =>
  DISALLOWED_DISPLAY_NAME_CHARS.test(value);
